import { Invoice } from '@medplum/fhirtypes';
import { MedplumClient } from '@medplum/core';
import { useGenericResourceSearch } from '@/hooks/useGenericResourceSearch';
import {
  paymentSearchConfig,
  type PaymentSearchParams,
} from '../payments/paymentSearchConfig';

export const usePaymentSearch = (medplum: MedplumClient, patientId?: string) => {
  return useGenericResourceSearch<PaymentSearchParams, Invoice>(
    medplum,
    paymentSearchConfig,
    patientId
  );
}
